import { Select, type SelectProps } from '@atlas/shared/client/ui/Select';
import { TogglePillGroup, type TogglePillGroupOption } from '@atlas/shared/client/ui/TogglePillGroup';
import type { FormFieldInputProps } from '@atlas/shared/client/form/components/form-field/FormField.types';

type CivilityOption = {
    value: string | number | boolean;
    label: string;
    'aria-label'?: string;
};

export type CivilitiesProps = FormFieldInputProps & {
    options: CivilityOption[];
};

const Civility: React.FC<CivilitiesProps> = ({ options, value, onChange, disabled, required, label }) => {
    if (options.length > 4) {
        return (
            <Select
                options={options as SelectProps['options']}
                value={value}
                onChange={onChange}
                isDisabled={disabled}
                label={label}
            />
        );
    }

    return (
        <TogglePillGroup
            key={String(value)}
            options={options as TogglePillGroupOption[]}
            defaultSelectedKey={value !== undefined ? String(value) : undefined}
            disallowEmptySelection
            onSelectionChange={(key) => {
                if (onChange && key !== null) {
                    const selected = options.find((opt) => String(opt.value) === key);
                    if (selected) onChange(selected.value as string);
                }
            }}
            isDisabled={disabled}
            isRequired={required}
            label={typeof label === 'string' ? label : undefined}
        />
    );
};

export { Civility };
